import type { Settings } from '../types';

const envVoice = __ELEVENLABS_VOICE_ID__ || '';

export function getElevenVoiceId(_settings: Settings): string | undefined {
  return envVoice || undefined;
}
